import { createContext } from "react";

const BasketContext = createContext();

export default BasketContext